module.exports = __webpack_public_path__ + "static/media/Chrome.ad1969c0.svg";